import { Address as AddressType } from '@shared/types'
import { JSX } from 'react'

import { DomesticAddressFields } from './DomesticAddressFields'
import { ForeignAddressFields } from './ForeignAddressFields'

interface AddressProps {
  address: AddressType
}

export const Address = ({ address }: AddressProps): JSX.Element => {
  if (address.domesticAddress) {
    return (
      <DomesticAddressFields
        address={{
          street: address.domesticAddress.street,
          postalCode: address.domesticAddress.postalCode,
          postOffice: address.domesticAddress.postOffice,
          countryName: address.domesticAddress.countryName,
        }}
      />
    )
  }
  if (address.foreignAddress) {
    return (
      <ForeignAddressFields
        address={{
          street: address.foreignAddress.street,
          foreignAddressLine1: address.foreignAddress.foreignAddressLine1,
          foreignAddressLine2: address.foreignAddress.foreignAddressLine2,
          countryName: address.foreignAddress.countryName,
        }}
      />
    )
  }
  return <DomesticAddressFields address={{}} />
}
